import { Injectable } from '@angular/core';

import { DateService } from './date.service';
import { Constants } from '@shared/models';
import type { TReportOptions } from '@shared/models';
const DateTimeFormats = Constants.DateTimeFormats;

const NUM_ROWS_IN_PAGE_HEADER = 5;
const NUM_ROWS_IN_COLUMN_HEADER = 3;
const NUM_ROWS_IN_PAGE_AND_COLUMN_HEADER = NUM_ROWS_IN_PAGE_HEADER + NUM_ROWS_IN_COLUMN_HEADER;
const MAX_ROWS_PER_PAGE = 33;   // For portrait mode

@Injectable({
    providedIn: 'root'
})
export class ReportFormatterService {
    private dateService: DateService = new DateService();

    public buildReportPages(options: TReportOptions, reportData: any): any {
        const pages: any[] = [];
        const pageHeader = this.buildReportPageHeader(options);
        
        this.buildPages(pages, reportData);
        pageHeader.numReportPages = pages.length;
        
        return { pageHeader, pages };
    }

    private buildPages(pages: any[], reportData: any): void {
        let rowIndex = -1;
        let pageRowNum = 0;
        let pageNum = 0;
        let rowInfo: any;
        
        do {
            const page: any = {};
            page.pageNumber = ++pageNum;
            pageRowNum = NUM_ROWS_IN_PAGE_AND_COLUMN_HEADER;

            do {
                rowInfo = reportData.data[++rowIndex];
                if (rowInfo) {
                    this.addRowInfoToPage(page, rowInfo);
                    ++pageRowNum;
                }
            } while (rowInfo && pageRowNum < MAX_ROWS_PER_PAGE);

            if (page.dataRows !== undefined || page.summaryRows !== undefined) {
                pages.push(page);
            }
        } while (rowInfo);
    }

    private addRowInfoToPage(page: any, rowInfo: any): void {
        const row = { cells: rowInfo.cells, myClass: rowInfo.myClass };

        if (rowInfo.type === 'data') {
            page.dataRows = (page.dataRows || []);
            page.dataRows.push(row);
        } else {
            page.summaryRows = (page.summaryRows || []);
            page.summaryRows.push(row);
        }
    }

    private buildReportPageHeader(options: TReportOptions): any {
        const pageHeader: any = {};

        pageHeader.asOfDate = this.dateService.formatTimestamp('now', DateTimeFormats.LongDate);
        pageHeader.reportTitle = options.selectedReport!.title;
        pageHeader.headerColumns = options.selectedReport!.columns;

        if (options.startingDate !== undefined) {
            pageHeader.startingDate = this.dateService.formatTimestamp(options.startingDate, DateTimeFormats.LongDate);
            pageHeader.endingDate = this.dateService.formatTimestamp(options.endingDate!, DateTimeFormats.LongDate);
            pageHeader.reportPeriod = this.dateService.computeDuration(options.endingDate!, options.startingDate);
        }

        return pageHeader;
    }
}